








































































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class MyPageUserInfo extends Vue {
    get planName() {
        return this.$store.state.customer.userdata?.plan || ''
    }

    get nextPayAt() {
        const timestamp = this.$store.state.customer.userdata?.next_pay_at
        if (!timestamp) {
            return ''
        }
        return new Date(timestamp * 1000).toLocaleDateString()
    }

    get kiminiId() {
        return this.$store.state.customer.userdata?.kimini.id
    }
}
